import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=dcc40a0e&scoped=true&"
import script from "./PrimaryButton.vue?vue&type=script&lang=js&"
export * from "./PrimaryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc40a0e",
  null
  
)

export default component.exports